import IFormModel from "@/models/IFormModel";
import {Salutation} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";
import RequiredValidator from "@/validators/RequiredValidator";
import EmailValidator from "@/validators/EmailValidator";
import {PhoneValidator} from "@/validators/PhoneValidator";
import {StringLengthValidator} from "@/validators/StringLengthValidator";
import {NumberValidator} from "@/validators/NumberValidator";

export default class CartPositionBulkOfferRequestCreate implements IFormModel {

	public remark: string | null = null;
	public locale: string | null = null;
	public company: string | null = null;
	public salutation: Salutation | null = Salutation.mr;
	public firstname: string | null = null;
	public lastname: string | null = null;
	public street: string | null = null;
	public houseNumber: string | null = null;
	public zip: string | null = null;
	public city: string | null = null;
	public email: string | null = null;
	public phone: string | null = null;
	public additionalScaleQuantity1Meters: number | null = null;
	public additionalScaleQuantity2Meters: number | null = null;

	public reset(): void {
		this.remark = null;
		this.locale = null;
		this.company = null;
		this.salutation = Salutation.mr;
		this.firstname = null;
		this.lastname = null;
		this.street = null;
		this.houseNumber = null;
		this.zip = null;
		this.city = null;
		this.email = null;
		this.phone = null;
		this.additionalScaleQuantity1Meters = null;
		this.additionalScaleQuantity2Meters = null;
	}

	public normalize(): void {
		this.additionalScaleQuantity1Meters = CartPositionBulkOfferRequestCreate.normalizeQuantity(this.additionalScaleQuantity1Meters);
		this.additionalScaleQuantity2Meters = CartPositionBulkOfferRequestCreate.normalizeQuantity(this.additionalScaleQuantity2Meters);
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'salutation':
				return this.requiredRule('cart.bulkOffer.salutation');
			case 'firstname':
				return this.requiredRule('cart.bulkOffer.firstname');
			case 'lastname':
				return this.requiredRule('cart.bulkOffer.lastname');
			case 'street':
				return this.requiredRule('cart.bulkOffer.street');
			case 'houseNumber':
				return this.requiredRule('cart.bulkOffer.houseNumber');
			case 'zip':
				return this.requiredRule('cart.bulkOffer.zip');
			case 'city':
				return this.requiredRule('cart.bulkOffer.city');
			case 'email':
				return [
					(new RequiredValidator('cart.bulkOffer.email')).validationRule(),
					(new EmailValidator('cart.bulkOffer.email')).validationRule(),
				];
			case 'phone':
				return [(new PhoneValidator('cart.bulkOffer.phone')).validationRule()];
			case 'additionalScaleQuantity1Meters':
				return [(new NumberValidator('cart.bulkOffer.additionalScaleQuantity1', true, 0.01)).validationRule()];
			case 'additionalScaleQuantity2Meters':
				return [(new NumberValidator('cart.bulkOffer.additionalScaleQuantity2', true, 0.01)).validationRule()];
			case 'remark':
				return [(new StringLengthValidator('cart.bulkOffer.remark', true, null, 2000)).validationRule()];
			default:
				return [];
		}
	}

	private requiredRule(label: string): ValidationRule[] {
		return [(new RequiredValidator(label)).validationRule()];
	}

	private static normalizeQuantity(value: number | string | null | undefined): number | null {
		if (value === null || value === undefined || value.toString() === '') return null;

		return Number(value);
	}

}
